/*
 * @Author: Json Chen
 * @Date: 2021-06-30 10:35:04
 * @LastEditTime: 2022-06-13 15:03:16
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelLanguage/Components/AvailableLanguagesTable.tsx
 */

import { Button } from '@/src/components/Antd';
import DroppableTable from 'src/components/DroppableTable/EditDraggableTable';
import ModalDelHOC from '@/src/constrains/ModalDelHOC';
import React from 'react';
import styles from '../style.module.less';
import AvailableLanguagesModalForm from './AvailableLanguagesModalForm';
import TranslationSettingModal from './TranslationSettingModal';
import { getAllLanguage } from '@/src/request/common/index';
import { useRequest } from 'ahooks';
import { TableInput } from 'src/components/EditableTable/TableForm1';
import { EditIcon } from '@/src/components/EditableTable/EditableTable';
import { get } from 'lodash';
import { useI18n } from 'src/hooks/useRouterChange';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
import { Popover } from 'antd';
import { Icon } from '@/src/tools/icon';
import { replaceI18nVariables } from '@/src/tools/tools';

import { TRANSLATION_MODE, TRANSLATION_POWER } from '../constants';

const TIPCONTENTSTRATEGY = {
  confirm: {
    title: getI18nFromGeneral('general.tIPCONTENTSTRATEGY.confirmtitle'),
    content: getI18nFromGeneral('general.tIPCONTENTSTRATEGY.confirmcontent'),
    buttonType: 'primary',
    okText: getI18nFromGeneral('general.antd.Modal.ModalFooter.confirm'),
  },
  delete: {
    title: getI18nFromGeneral('general.tIPCONTENTSTRATEGY.deletetitle'),
    content: getI18nFromGeneral('general.tIPCONTENTSTRATEGY.deletecontent'),
    buttonType: 'danger',
    okText: getI18nFromGeneral('general.antd.Modal.ModalFooter.delete'),
  },
  forbid: {
    title: 'Delete Language',
    content: ({ current, sourceOf, reason }) => {
      const i18n = useI18n();
      const getI18n = (str) => i18nGet(i18n, str);
      if (reason === 'SOURCE' && sourceOf?.length > 0) {
        return (
          <div>
            {replaceI18nVariables(
              getI18n('salesChannelLanguage.index.deleteSourceLanguageTips'),
              sourceOf.join(','),
            )}
          </div>
        );
      }
      return 'This language cannot be deleted';
    },
    buttonType: 'primary',
    okText: getI18nFromGeneral('general.antd.Modal.ModalFooter.confirm'),
  },
};

const AvailableLanguagesTable = ({
  value: availableLanguages = [],
  onCustomChange: onChange,
  onChange: _onChange,
  onDelClick,
  disableEdit,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const _availableLanguages = availableLanguages;
  const primaryLanguage = availableLanguages.find((i) => i.primary);
  const { data: languageOptionsList = [] } = useRequest(getAllLanguage);
  const primaryTag = get(primaryLanguage, 'tag');
  const availabilityConfig = React.useMemo(() => {
    if (primaryTag) {
      return {
        [primaryTag]: {
          disableDrag: true,
          hideDragger: false,
        },
      };
    }
    return {};
  }, [primaryTag]);

  const [formModalVisible, setFormModalVisible] =
    React.useState<boolean>(false);
  const [translationSettingModalVisible, setTranslationSettingModalVisible] =
    React.useState<boolean>(false);
  const [attrIndex, setAttrIndex] = React.useState<number>(-1);

  const availableLanguagesColumns = React.useMemo(() => {
    return [
      {
        title: getI18n('salesChannelLanguage.index.language'),
        key: 'description',
        dataIndex: 'description',
        default: true,
        width: 348,
        textWrap: 'word-break',
        childGenerate: (text, record, index) => {
          return <div className={styles.tb}>{text}</div>;
        },
      },
      {
        title: getI18n('salesChannelLanguage.index.languageTag'),
        key: 'tag',
        dataIndex: 'tag',
        default: true,
        width: 180,
        textWrap: 'word-break',
        childGenerate: (text: string) => {
          return <div className={styles.tb}>{text}</div>;
        },
      },
      {
        title: (
          <span>
            {getI18n('salesChannelLanguage.index.nativeLanguageName')}
            <EditIcon />
          </span>
        ),
        key: 'name',
        dataIndex: 'name',
        default: true,
        width: 180,
        textWrap: 'word-break',
        childGenerate: (text: string, record, index) => {
          const { tag } = record;
          return (
            <TableInput
              className={styles.tb}
              value={text}
              onChange={(e) => {
                const availableLanguages = [..._availableLanguages];
                (availableLanguages[index] || {}).name = e;
                _onChange(availableLanguages);
              }}
              label={text}
              onBlurCallback={(cb) => {
                if (!text) {
                  const availableLanguages = [..._availableLanguages];
                  (availableLanguages[index] || {}).name = tag;
                  _onChange(availableLanguages);
                }
                if (cb) {
                  cb();
                }
              }}
            />
          );
        },
      },
      {
        title: () => {
          return (
            <div className={styles.title}>
              <span>
                {getI18n('salesChannelLanguage.index.translationSetting')}
              </span>
              <Popover
                title={null}
                content={<Hint />}
                placement='right'
                getPopupContainer={() => document.body}
                overlayStyle={{ maxWidth: 310, whiteSpace: 'normal' }}>
                <Icon type='icontooltip' className={styles.icon} />
              </Popover>
            </div>
          );
        },
        key: 'translationSetting',
        dataIndex: 'translationSetting',
        default: true,
        width: 450,
        textWrap: 'word-break',
        childGenerate: (text: Record<string, any>, record) => {
          const { primary } = record;

          return (
            <div className={styles.tb}>
              {primary
                ? ''
                : replaceI18nVariables(
                    getI18n(`salesChannelLanguage.index.translatefrom`),
                    (() => {
                      const sourceTag = text?.sourceLanguage;
                      const sourceLanguage = availableLanguages.find(
                        (item) => item.tag === sourceTag,
                      );
                      return sourceLanguage?.description || sourceTag || '';
                    })(),
                  )}
            </div>
          );
        },
      },
      disableEdit
        ? {}
        : {
            title: getI18n(
              'general.advancedFilters.commonStoreProductsWithTable.actions',
            ),
            default: true,
            optional: true,
            width: 140,
            childGenerate: (_, record, index) => {
              const { primary } = record;

              return (
                <div
                  className={styles.action}
                  style={{ justifyContent: 'normal' }}>
                  {!primary && (
                    <span
                      className={styles.primary}
                      onClick={() => showTranslationSettingModal(index)}
                      style={{ marginRight: '35px' }}>
                      {getI18n('general.edit')}
                    </span>
                  )}
                  <span
                    className={styles.danger}
                    onClick={() => onDelClick(index)}>
                    {getI18n('general.delete')}
                  </span>
                </div>
              );
            },
          },
    ];
  }, [_availableLanguages]);

  const showFormModal = () => {
    setFormModalVisible(true);
  };

  const showTranslationSettingModal = (index) => {
    setAttrIndex(index);
    setTranslationSettingModalVisible(true);
  };
  const hideTranslationSettingModal = () => {
    setTranslationSettingModalVisible(false);
  };
  const onTableChange = (data) => {
    onChange(data, 'SORT');
  };

  const hideFormModal = () => {
    setFormModalVisible(false);
  };
  const onFormModalConfirm = (data) => {
    const _data = availableLanguages.concat({
      ...data,
      tag: data.languageTag,
      translationSetting: {
        language: data?.languageTag || '',
        sourceLanguage: primaryLanguage?.tag || '',
        targetLanguage: data?.languageTag || '',
        translationMode: TRANSLATION_MODE.TRANSLATE,
        translationPower: TRANSLATION_POWER.QWEN,
      },
    });
    onChange(_data, 'ADD');
    hideFormModal();
  };
  const onTranslationFormModalConfirm = (index, data) => {
    const {
      additionalRequirement,
      sourceLanguage,
      targetLanguage,
      translationMode,
      translationPower,
    } = data;
    const item = availableLanguages[index];
    item.translationSetting = {
      language: item?.tag || '',
      additionalRequirement: additionalRequirement || '',
      sourceLanguage: sourceLanguage?.value || '',
      targetLanguage: targetLanguage?.value || '',
      translationMode: translationMode?.value || TRANSLATION_MODE.TRANSLATE,
      translationPower: translationPower?.value || TRANSLATION_POWER.QWEN,
    };
    onChange(availableLanguages, 'ADD_TRANSLATE');
    hideTranslationSettingModal();
  };
  const Hint = () => {
    const i18n = useI18n();
    const getI18n = (str) => i18nGet(i18n, str);
    return (
      <div className={styles.hint}>
        <div className={styles.paragraph}>
          {getI18n('salesChannelLanguage.index.translationTip1')}
          <br />
          {getI18n('salesChannelLanguage.index.translationTip2')}
          <br />
          {getI18n('salesChannelLanguage.index.translationTip3')}
          <br />
          {getI18n('salesChannelLanguage.index.translationTip4')}
        </div>
      </div>
    );
  };

  return (
    <div className={styles.tableAvailableLanguage}>
      <DroppableTable
        id='LanguageSetting'
        rowKey={'tag'}
        className={styles.table}
        dataSource={_availableLanguages}
        columns={availableLanguagesColumns}
        onTableChange={onTableChange}
        pagination={false}
        hideAllDragHandlers={disableEdit}
        availabilityConfig={availabilityConfig}
      />
      <Button type='primary' onClick={showFormModal} disabled={disableEdit}>
        {getI18n('salesChannelLanguage.index.addAvailableLanguage')}
      </Button>
      <AvailableLanguagesModalForm
        visible={formModalVisible}
        onCancel={hideFormModal}
        onModalConfirm={onFormModalConfirm}
        availableLanguages={availableLanguages}
        languageOptionsList={languageOptionsList}
      />
      <TranslationSettingModal
        visible={translationSettingModalVisible}
        attrData={availableLanguages}
        attrIndex={attrIndex}
        onCancel={hideTranslationSettingModal}
        onModalConfirm={onTranslationFormModalConfirm}
        availableLanguages={availableLanguages}
        languageOptionsList={languageOptionsList}
      />
    </div>
  );
};

export default ModalDelHOC(AvailableLanguagesTable, {
  modalDataStrategy: TIPCONTENTSTRATEGY,
  canDel: ({ list, index }) => {
    return !list[index].primary;
  },
  getDelReason: ({ list, index }) => {
    const current = list[index];
    if (current.primary) return 'PRIMARY';
    const currentTag = current.tag;
    const isSourceOfOthers = (list || []).some(
      (item, i) =>
        i !== index && item.translationSetting?.sourceLanguage === currentTag,
    );

    return isSourceOfOthers ? 'SOURCE' : null;
  },
});
